import { FC, useState } from "react";
import { Button, Stack, Text } from "@chakra-ui/react";

import { CHDPModalInfo } from "./CHDPModalInfo";
import { CHDPModalAmount } from "./CHDPModalAmount";
import { CHDPModalCheckbox } from "./CHDPModalCheckbox";

interface Props {
  amount: string;
  approveCHDP: () => void;
  onCancel: () => void;
}

export const PaymentBlockCHDPModal: FC<Props> = ({ amount, approveCHDP, onCancel }) => {
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const handleCheck = () => {
    setIsError(false);
    setIsChecked(prev => !prev);
  };

  const handleApprove = () => {
    if (!isChecked) {
      setIsError(true);
      return;
    }

    approveCHDP();
  };

  return (
    <Stack spacing={0}>
      <CHDPModalInfo />
      <CHDPModalAmount amount={amount} />
      <CHDPModalCheckbox onChange={handleCheck} isChecked={isChecked} isError={isError} />

      <Stack h="22px" mx="12px" mt="2px">
        {isError && (
          <Text variant="red" fontSize="14px">
            Подтвердите, чтобы продолжить
          </Text>
        )}
      </Stack>

      <Button mt="31px" mb="6px" colorScheme="brand" onClick={handleApprove}>
        Продолжить
      </Button>
      <Button onClick={onCancel}>
        Закрыть
      </Button>
    </Stack>
  );
};
